import Logger from '../helpers/Logger'
import { IMetricsClient } from './MetricsTracker'

export class MetricsLocalClient implements IMetricsClient {
  record(eventName: string, data: object): void {
    Logger.custom(['debug', 'metrics'], eventName, data)
  }
}
